import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast, Button, Dialog } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import { toWxMiniProgram } from '../../api/createHttpRequest';
import DoctorAvatar from '../../static/images_cso/doctor_avatar.png';
import Material from '../../static/images_cso/material.png';
import Key from '../../static/images_cso/key.png';
import Email from '../../static/images_cso/email.png';
import right_arrow_white from '../../static/images_cso/right_arrow_white.svg';
import copy from '../../static/images_cso/copy.png';
import utils from '../../utils/utils';
const api = new ApiCore();


const CSOPersonal = (props: any) => {

    const [doctorInfo, setDoctorInfo] = useState<any>({});

    useEffect(() => {
        getInfo()
        return () => {
        }
    }, [])

    const getInfo = () => {
        api.getCsoDoctorInfo().then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || {};
                setDoctorInfo(_data);
            }
        });
    }


    const toAuthLogin = () => {
        toWxMiniProgram('/pages/index/index?needLogin=1');
    }

    const toVerify = () => {
        toWxMiniProgram('/pages/csoComplete/csoComplete');
    }


    const toMenu = async (type: any) => {

        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }

        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest && (auditState !== 1 && auditState !== 4) && utils.isMiniProgram()) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else {
            if (type == 'personalCenter') {
                props.history.push('/cso/doctor/personalCenter')
            } else if (type == 'feedback') {
                props.history.push('/cso/doctor/feedback')
            } else if (type == 'privacy') {
                props.history.push('/cso/doctor/privacy')
            }
        }
    }

    const toLogout = async() => {
        const result = await Dialog.confirm({
            content: '确认退出登录？',
        })
        if (result) {
            sessionStorage.clear();
            const CSOMedicalConsult = localStorage.getItem('CSO_Medical_Consult');
            localStorage.clear();
            if (CSOMedicalConsult) {
                localStorage.setItem('CSO_Medical_Consult', CSOMedicalConsult);
            }
            if (doctorInfo.identityType != 5) {
                toWxMiniProgram('/pages/index/index?logout=1');
            } else {
                toWxMiniProgram('/pages/freeLogin/freeLogin?logout=1');
            }
        }
    }

    let auditState = doctorInfo?.state;
    let isGuest = false;
    let token = sessionStorage.getItem('token');
    if (token) {
        let tokens = JSON.parse(token);
        if (tokens.isGuest) {
            isGuest = true;
        }
    }

    const onKeFuIdCopy = () => {
        let copyInput = document.createElement('input'); // 创建input元素
        document.body.appendChild(copyInput); // 向页面底部追加输入框
        copyInput.setAttribute('value', doctorInfo.code); // 添加属性，将url赋值给input元素的value属性
        copyInput.style = 'opacity: 0;'
        copyInput.select(); // 选择input元素
        document.execCommand('Copy'); // 执行复制命令
        copyInput.remove();
        Toast.show('复制成功');
    }

    // 是否是合格的医生
    const isValidDoctor = (auditState == 1 || auditState == 4);
    const doctorReady = (doctorInfo && Object.keys(doctorInfo).length > 0)

    return (
        <div className={styles.CSO_personal_content}>
            <div className={styles.head}>
                <div className={styles.heads}>
                    <img className={styles.h_l} src={DoctorAvatar} alt="" />
                    <>
                        { 
                            doctorReady &&
                            <>
                            {
                                isGuest ?
                                    <div className={styles.h_m}>
                                        <div className={styles.h_m_t}>
                                            <div className={styles.h_m_t_l}>游客登录</div>
                                        </div>
                                        <div className={styles.h_m_b} onClick={toAuthLogin}>
                                            <div className={styles.h_m_b_l_t}>点击前往完成授权登录</div>
                                            <img className={styles.h_m_b_r_img} src={right_arrow_white} alt="" />
                                        </div>
                                    </div>
                                    :
                                    isValidDoctor ?
                                        <div className={`${styles.h_m} ${doctorInfo.identityType == 5 ? `${styles.h_m_center}` : ''}`}>
                                            <div className={styles.h_m_t}>
                                                <div className={styles.h_m_t_l}>{ doctorInfo.identityType !== 5 ? doctorInfo.name : doctorInfo.code }</div>
                                                {
                                                    doctorInfo.identityType != 4 && doctorInfo.identityType != 5 && doctorInfo.title &&
                                                    <div className={styles.h_m_t_r}>{doctorInfo.title}</div>
                                                }
                                                {
                                                    doctorInfo.identityType == 5 &&
                                                    <div className={styles.copy} onClick={onKeFuIdCopy} >
                                                        <img src={copy} alt="" />
                                                    </div>
                                                }
                                            </div>
                                            {
                                               (!doctorInfo.identityType || doctorInfo.identityType == 1 || doctorInfo.identityType == 3) ?
                                                <div className={styles.h_m_b}>
                                                    <div className={styles.h_m_b_l}>{doctorInfo.institution}</div>
                                                    { 
                                                        doctorInfo.dept && 
                                                        <>
                                                            <div className={styles.h_m_b_m}></div>
                                                            <div className={styles.h_m_b_r}>{doctorInfo.dept}</div>
                                                        </>
                                                    }
                                                </div> 
                                                :
                                                doctorInfo.identityType != 5 ?
                                                <div className={styles.h_m_b}>
                                                    <div className={styles.h_m_b_l}>{doctorInfo.code.replace( /(\d{3})\d{4}(\d{4})/, "$1 **** $2")}</div>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                        :
                                        <div className={styles.h_m}>
                                            <div className={styles.h_m_t}>
                                                <div className={styles.h_m_t_l}>暂未认证</div>
                                            </div>
                                            <div className={styles.h_m_b} onClick={toVerify}>
                                                <div className={styles.h_m_b_l_t}>点击前往完成身份认证</div>
                                                <img className={styles.h_m_b_r_img} src={right_arrow_white} alt="" />
                                            </div>
                                        </div>
                            }
                            </>
                        }
                    </>
                </div>
            </div>



            <div className={styles.cso_menus}>
                {
                    doctorInfo.identityType !== 5  &&
                    <div className={styles.cso_menu} onClick={() => toMenu('personalCenter')}>
                        <div className={styles.menuName}>
                            <img src={Material} alt="" />
                            <span>我的资料</span>
                        </div>
                        <div className={styles.rightArrow}></div>
                    </div>
                }
                <div className={styles.cso_menu} onClick={() => toMenu('privacy')}>
                    <div className={styles.menuName}>
                        <img src={Key} alt="" />
                        <span>用户协议&隐私政策</span>
                    </div>
                    <div className={styles.rightArrow}></div>
                </div>
                <div className={styles.cso_menu} onClick={() => toMenu('feedback')}>
                    <div className={styles.menuName} >
                        <img src={Email} alt="" />
                        <span>意见反馈</span>
                    </div>
                    <div className={styles.rightArrow}></div>
                </div>
            </div>

            <div className={styles.logout} onClick={() => { toLogout() }}>
                退出登录
            </div>

        </div>
    )
}

export default withRouter(CSOPersonal);